
import React from 'react';

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  // Improved markdown to HTML conversion
  const convertMarkdownToHtml = (text: string): string => {
    let html = text;
    
    // Headers - process in order from most specific to least
    // Shift all headers down one level to maintain proper hierarchy (post title is H1)
    html = html.replace(/^### (.*$)/gim, '<h4 class="text-base font-semibold mt-4 mb-2">$1</h4>');
    html = html.replace(/^## (.*$)/gim, '<h3 class="text-lg font-bold mt-6 mb-3">$1</h3>');
    html = html.replace(/^# (.*$)/gim, '<h2 class="text-xl font-bold mt-8 mb-4">$1</h2>');
    
    // Bold and italic
    html = html.replace(/\*\*\*(.*?)\*\*\*/g, '<strong><em>$1</em></strong>');
    html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
    
    // Code blocks and inline code
    html = html.replace(/```([\s\S]*?)```/g, '<pre class="bg-gray-100 p-3 rounded text-sm overflow-x-auto"><code>$1</code></pre>');
    html = html.replace(/`([^`]+)`/g, '<code class="bg-gray-100 px-1 py-0.5 rounded text-sm">$1</code>');
    
    // Markdown links (existing functionality)
    html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" class="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">$1</a>');
    
    // Auto-detect URLs - improved to avoid conflicts with existing HTML
    html = html.replace(/(?<![href="'])(https?:\/\/[^\s<>"]+)(?![^<]*>)/g, '<a href="$1" class="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">$1</a>');
    
    // Auto-detect www URLs - improved pattern to avoid conflicts
    html = html.replace(/(?<![href="']|@)(\bwww\.[a-zA-Z0-9][-a-zA-Z0-9]*[a-zA-Z0-9]*\.[-a-zA-Z0-9]+[^\s<>"]*)(?![^<]*>)/g, '<a href="http://$1" class="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">$1</a>');
    
    // Lists - handle both * and - markers
    html = html.replace(/^[\*\-] (.*)$/gim, '<li class="ml-4 mb-1">$1</li>');
    
    // Wrap consecutive list items in ul tags
    html = html.replace(/(<li[^>]*>.*?<\/li>\s*)+/gs, '<ul class="list-disc pl-6 mb-4">$&</ul>');
    
    // Blockquotes
    html = html.replace(/^> (.*)$/gim, '<blockquote class="border-l-4 border-gray-300 pl-4 italic text-gray-700 my-4">$1</blockquote>');
    
    // Horizontal rules
    html = html.replace(/^---$/gim, '<hr class="border-t border-gray-300 my-6">');
    
    // Line breaks and paragraphs
    html = html.replace(/\n\n+/g, '</p><p class="mb-4">');
    html = html.replace(/\n/g, '<br>');
    
    return html;
  };

  const htmlContent = convertMarkdownToHtml(content);
  
  return (
    <div className="prose prose-sm max-w-none">
      <div 
        className="mb-4"
        dangerouslySetInnerHTML={{ __html: `<p class="mb-4">${htmlContent}</p>` }}
      />
    </div>
  );
};

export default MarkdownRenderer;
